import sgmManager from '@/utils/sgmUtils';
import { isNextClient } from '@/intl-jdi-common-ssr/utils/uaParser';
import pino, { LoggerOptions, multistream } from 'pino';

// 基于 pino 的日志对象接口，必须包含 eventName
interface LogObject {
  eventName: string;
  [key: string]: any;
}

// 扩展 pino 的 Logger 接口，只保留 info 和 error 方法
interface CustomPinoLogger {
  info: (obj: LogObject, msg?: string) => void;
  error: (obj: LogObject, msg?: string) => void;
}

const pinoOption: LoggerOptions = {
  timestamp: () => `,"time":"${new Date().toISOString()}"`,
  level: 'info', // 设置根日志级别
};

// 因为行云限制，目录文件需要放到/export/Logs/下，所以需要判断环境
const basePath = process.env.NEXT_PUBLIC_APP_ENV === 'development' ? '' : '/export/Logs/';

// 判断是否在 build 阶段，避免 build 报错
const isBuilding = process.env.npm_lifecycle_event?.startsWith('build');

// 服务器端 Logger
let serverLogger: CustomPinoLogger | undefined;

// 仅在非 build 阶段且 pino.destination 存在时初始化 serverLogger
if (!isBuilding && pino.destination) {
  const streams = [
    // 所有级别日志写入 app.log
    {
      stream: pino.destination({
        dest: `${basePath}app.log`,
        sync: false,
      }),
    },
    // 仅错误级别写入 error.log
    {
      level: 'error',
      stream: pino.destination({
        dest: `${basePath}error.log`,
        sync: true, // 错误日志使用同步写入确保不丢失
      }),
    },
  ];

  serverLogger = pino(pinoOption, multistream(streams));
}

// 浏览器端自定义 Logger
const clientLogger = {
  info: (args: any) => {
    sgmManager.infoLog(args);
  },
  error: (args: any) => {
    sgmManager.errorLog(args);
  },
};

export const logger = isNextClient() ? clientLogger : serverLogger ?? console;
